import { supabase } from './supabase'

/**
 * Save a quote to Supabase.
 * Table: cable_quotes
 * RLS: users can only read/write their own quotes (filtered by user_id = auth.uid())
 */
export async function saveQuote({ quoteType, name, configuration, pricing, weight }) {
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) throw new Error('Not authenticated')

  const { data, error } = await supabase
    .from('cable_quotes')
    .insert({
      user_id: user.id,
      user_email: user.email,
      quote_type: quoteType,
      name: name || `${quoteType} quote`,
      configuration,
      pricing,
      weight: weight || null,
    })
    .select()
    .single()

  if (error) throw error
  return data
}

/**
 * Fetch all quotes for the current user, newest first.
 */
export async function getQuotes() {
  const { data, error } = await supabase
    .from('cable_quotes')
    .select('*')
    .order('created_at', { ascending: false })

  if (error) throw error
  return data
}

/**
 * Delete a quote by id.
 */
export async function deleteQuote(id) {
  const { error } = await supabase
    .from('cable_quotes')
    .delete()
    .eq('id', id)

  if (error) throw error
}
